export default {"src":"/_next/static/media/facebook.dd9bb54d.ico","height":292,"width":306,"blurWidth":0,"blurHeight":0};